import React, {useState} from 'react';
import {Form, Input, Select, Switch, Button, Card, Row, Col, Typography, Modal, message, Space} from 'antd';
import {UserOutlined, PhoneOutlined, LockOutlined, CreditCardFilled, CreditCardOutlined} from '@ant-design/icons';
import './Common.module.css';
import styles from './Common.module.css';
import {addUserRequest} from "../api";

const {Title} = Typography;
const {Option} = Select;

const AddAccountForm = (props) => {
    const [form] = Form.useForm();
    const [accountStatus, setAccountStatus] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(true);

    const onFinish = (values) => {
        addUser()
        // 这里可以添加API调用或其他提交逻辑
    };


    const closeCommon = () => {
        props.closeCommonModal()
    };

    function addUser() {

        form.validateFields()
            .then(values => {
                console.log('表单数据:', values);


                var user_type = '1';
                var name = values.name;
                var phone = values.phone;
                var pwd = values.pwd;
                var initialPoints = values.initialPoints;
                var status = accountStatus === true ? '1' : '3';

                var beizhu = values.beizhu === undefined ? '' : values.beizhu;

                // 调用 API
                addUserRequest(user_type, name, phone, pwd, initialPoints, status, beizhu, (data) => {
                    console.log(data);
                    if (data.ret === '1') {
                        message.success("添加成功", 1);
                        props.updateData();
                        props.closeCommonModal()
                    } else {
                        message.error(data.msg, 1);
                    }
                });
            })
    }

    return (
        <Modal
            maskClosable={false}
            visible={true}
            onCancel={closeCommon}
            footer={null} // 设置 footer 为 null 移除默认按钮
            className="add-account-container">
            <Card className={styles["form-card"]}>
                <div className={styles["form-title"]}>添加账号信息</div>

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}

                    className="account-form"
                >
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item
                                label="账号类型"
                                name="accountType"
                                initialValue="普通用户"
                            >
                                <Select>
                                    <Option value="普通用户">普通用户</Option>
                                    {/*<Option value="管理员">管理员</Option>*/}
                                    {/*<Option value="超级管理员">超级管理员</Option>*/}
                                </Select>
                            </Form.Item>
                        </Col>

                    </Row>

                    <Form.Item
                        label="用户姓名"
                        name="name"
                        rules={[{required: true, message: '请输入用户姓名'}]}
                    >
                        <Input
                            placeholder="请输入用户姓名"
                            prefix={<UserOutlined/>}
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="手机号（账号）"
                        name="phone"
                        rules={[
                            {required: true, message: '请输入手机号'},
                            {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号'}
                        ]}
                    >
                        <Input
                            placeholder="请输入手机号"
                            prefix={<PhoneOutlined/>}
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="账号密码"
                        name="pwd"
                        rules={[
                            {required: true, message: '请输入账号密码'},
                            {min: 6, message: '密码长度至少为6位'}
                        ]}
                    >
                        <Input.Password
                            placeholder="请输入账号密码"
                            prefix={<LockOutlined/>}
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        label="账户初始积分"
                        name="initialPoints"
                        rules={[
                            {required: true, message: '请输入账户初始积分'},
                            // { min: 6, message: '请输入账户初始积分' }
                        ]}
                    >
                        <Input
                            placeholder="请输入账户初始积分"
                            prefix={<CreditCardOutlined/>}
                            size="large"
                        />
                    </Form.Item>

                    {/*  <Form.Item
            label="确认密码"
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              { required: true, message: '请确认密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="请再次输入密码"
              prefix={<LockOutlined />}
              size="large"
            />
          </Form.Item>*/}


                    <Form.Item
                        label=""
                        name="status"
                        valuePropName="checked"
                        initialValue={true}
                        colon={false}
                        style={{display: 'flex', alignItems: 'center'}}
                    >

                        <Space align="center" size={12}>
                            <span style={{marginRight: 10}}>账号状态</span>
                            <Switch
                                checked={accountStatus}
                                onChange={setAccountStatus}
                                checkedChildren="启用"
                                unCheckedChildren="禁用"
                                style={{backgroundColor: accountStatus ? '#52c41a' : '#bfbfbf'}}
                            />
                        </Space>


                    </Form.Item>


                    <Form.Item
                        label="备注"
                        name="beizhu"
                    >
                        <Input.TextArea
                            placeholder="请输入备注信息"
                            rows={4}
                        />
                    </Form.Item>

                    <Form.Item className={styles["form-actions"]}>

                        <Button

                            size="large"
                            onClick={() => {
                                form.resetFields()
                                closeCommon()
                            }
                            }
                        >
                            取消
                        </Button>

                        <Button type="primary"
                                htmlType="submit"
                                size="large" style={{marginLeft: 16}}
                            // onClick={() => {addUser()}}
                        >
                            确认
                        </Button>

                    </Form.Item>
                </Form>
            </Card>
        </Modal>
    );
};

export default AddAccountForm;

